// import React, {useState, useEffect} from 'react'
// import ResponseMsg2 from '../../general/ResponseMsg2';
// import HeadingArea from '../../general/HeadingArea';
// import { MdOutlineEdit } from 'react-icons/md';
// import { AiOutlineMinusCircle } from 'react-icons/ai';

// const TeacherAllocation = ({setLoading}) => {
//         const [response2, setResponse2] = useState({ message: '', status: 'success' });
// const [teacher, setTeacher] = useState([]);
// const [searchTerm, setSearchTerm] = useState('');
// const [timeTable, setTimeTable] = useState([]);
// const [isEditMode, setIsEditMode] = useState(false);
// const [selectedTeacher, setSelectedTeacher] = useState(null);
// const [selectedClass, setSelectedClass] = useState('');
// const [selectedSection, setSelectedSection] = useState('');
// const [selectedPeriods, setSelectedPeriods] = useState([]);
// const [selectedDay, setSelectedDay] = useState('');


// const handleEdit = (teacher) => {
//   const teacherEngagements = [];

//   timeTable.forEach((tt) => {
//     if (!tt.teacher_id) return;

//     let teacherJson = {};
//     try {
//       teacherJson = typeof tt.teacher_id === 'string' ? JSON.parse(tt.teacher_id) : tt.teacher_id;
//     } catch {
//       return;
//     }

//     for (const [periodLabel, subjects] of Object.entries(teacherJson)) {
//       for (const [subjectId, teacherId] of Object.entries(subjects)) {
//         if (teacherId === teacher.user_id) {
//           const subjectInfo = tt.periods?.[periodLabel];

//           if (
//             (subjectId === "null") || 
//             (subjectId !== "null" && subjectInfo?.id == subjectId)
//           ) {
//             teacherEngagements.push({
//               ttId: tt.id,
//               label: periodLabel,
//               subject: subjectId === "null" ? 'Free Period' : subjectInfo.sub_name,
//               subjectId: subjectId === "null" ? "null" : subjectInfo.id,
//               myClass: tt.class_name,
//               section: tt.section,
//               day: tt.day
//             });
//           }
//         }
//       }
//     }
//   });

//   setSelectedTeacher(teacher);
//   setSelectedPeriods(teacherEngagements);
//   setIsEditMode(true);
// };


//          const fetchEmp = async () => {
//                           setLoading(true);
//                   try {
//                       const response = await fetch('https://api.kcian.in/get-employee');
      
//                       if (response.ok) {
//                           const data = await response.json();
//  const filteredData = data.filter(emp => emp.role == 'Teacher');
//                           setTeacher(filteredData);
//                           setLoading(false);
//                       } else {
//                           setLoading(false);
//                           console.error('Failed to fetch employee');
//                       }
//                   } catch (error) {
//                       setLoading(false);
//                       console.error('Error fetching data:', error);
//                   }
//     }


//                 const fetchTimeTable = async () => {
//                             setLoading(true);
//                     try {
//                         const response = await fetch('https://api.kcian.in/get-time-table');
        
//                         if (response.ok) {
//                             const data = await response.json();
//                             setTimeTable(data);
//                             setLoading(false);
//                         } else {
//                             setLoading(false);
//                             console.error('Failed to fetch class');
//                         }
//                     } catch (error) {
//                         setLoading(false);
//                         console.error('Error fetching data:', error);
//                     }
//       }
 
//      useEffect(() => {
//          fetchEmp();
//          fetchTimeTable();
//      }, []);
      

//        const filteredTeacher = teacher.filter(tt => {
//   const term = searchTerm.toLowerCase();
//   return (
//         tt.name.toLowerCase().includes(term) ||
//         tt.designation.toLowerCase().includes(term) ||
//         tt.user_id.toLowerCase().includes(term)
//   );
// });

// const classes = [...new Set(timeTable.map(item => item.class_name))];

// const sections = selectedClass
//   ? [...new Set(timeTable.filter(item => item.class_name === selectedClass).map(item => item.section))]
//   : [];

//   const days = selectedClass && selectedSection
//   ? [...new Set(
//       timeTable
//         .filter(item => item.class_name === selectedClass && item.section === selectedSection)
//         .map(item => item.day)
//     )]
//   : [];

// const periods = selectedClass && selectedSection && selectedDay
//   ? timeTable.filter(item => 
//       item.class_name === selectedClass && 
//       item.section === selectedSection &&
//       item.day === selectedDay
//     )
//   : [];


// const getTeacherEngagements = (teacherUserId) => {
//   const engagementsByDay = {};

//   timeTable.forEach((tt) => {
//     if (!tt.teacher_id) return;

//     let teacherJson = {};
//     try {
//       teacherJson = typeof tt.teacher_id === 'string' ? JSON.parse(tt.teacher_id) : tt.teacher_id;
//     } catch {
//       return;
//     }

//     for (const [periodLabel, subjects] of Object.entries(teacherJson)) {
//       for (const [subjectId, teacherId] of Object.entries(subjects)) {
//         if (teacherId === teacherUserId) {
//           const subjectInfo = tt.periods?.[periodLabel];
//           const isFreePeriod = subjectId === "null";

//           if (
//             (isFreePeriod) || 
//             (!isFreePeriod && subjectInfo?.id == subjectId)
//           ) {
//             const subName = isFreePeriod ? "Free Period" : subjectInfo.sub_name;
//             const subCode = isFreePeriod ? "" : subjectInfo.sub_code;
//             const subType = isFreePeriod ? "" : subjectInfo.sub_type;
//             const className = tt.class_name;
//             const section = tt.section;
//             const day = tt.day || "Unknown";

//             if (!engagementsByDay[day]) engagementsByDay[day] = [];

//             engagementsByDay[day].push(
//               `Period ${periodLabel}: ${subName}${subCode ? `(${subCode})` : ""}${
//                 subType ? ` (${subType === "Theory" ? "T" : "P"})` : ""
//               } - ${className}(${section})`
//             );
//           }
//         }
//       }
//     }
//   });

//   return Object.keys(engagementsByDay).length === 0 ? null : engagementsByDay;
// };

//   return (
//     <>
//                         <section className="py-4">
//         <div className="px-4">
//           <HeadingArea message1="Time Table" message2="Teacher Allocation" />

//        {response2.message && <ResponseMsg2 message={response2.message} status={response2.status} />}


// {!isEditMode && 
// <div className='profile-card'>
              
//   <div className='d-md-flex d-sm-flex justify-content-between mb-2'>
//             <span className="profile-heading align-content-center">Teacher Engagements</span>


//                   <div className='profile-input-area ms-auto col-lg-3 border-0'>
// <input
//   type='text'
//   name='search'
//   className='profile-input border-bottom rounded-0'
//   placeholder='Search Name, Reg Id, Designation'
//   value={searchTerm}
//   onChange={(e) => setSearchTerm(e.target.value)}
// />
// </div>
//   </div>


// <div className='table-responsive'>
// <table className='w-100'>

// <thead className='account-thead rounded-top-4'>
//   <tr>
//     <th>S No</th>
//     <th>Reg Id</th>
//     <th>Name</th>
//     <th>Father Name</th>
//     <th colSpan={7} className='text-center'>Engagements (in Days)</th>
//     <th>Designation</th>
//         <th>Activity</th>
//         </tr>

// <tr className='border-top'>
//     <th colSpan={4}></th>
//     <th className='border'>Mon</th>
//     <th className='border'>Tues</th>
//     <th className='border'>Wed</th>
//     <th className='border'>Thurs</th>
//     <th className='border'>Fri</th>
//     <th className='border'>Sat</th>
//     <th className='border'>Sun</th>
//     <th colSpan={2}></th>
//     </tr>

// </thead>

// {filteredTeacher.map((emp, index) => (
// <tr className='account-tr' key={emp.user_id}>
//   {(() => {
//     const engagementsByDay = getTeacherEngagements(emp.user_id);
//     const dayOrder = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'];

//     return (
//       <>
//         <td>{index + 1}</td>
//         <td>{emp.user_id}</td>
//         <td>{emp.name}</td>
//         <td>{emp.father || '--'}</td>

//         {dayOrder.map(day => (
//           <td className='border' key={day}>
//             {engagementsByDay && engagementsByDay[day] ? (
//               <ul className="mb-0 ps-3">
//                 {engagementsByDay[day].map((entry, idx) => (
//                   <li key={idx}>{entry}</li>
//                 ))}
//               </ul>
//             ) : (
//               <span className="text-muted">--</span>
//             )}
//           </td>
//         ))}

//         <td>{emp.designation || '--'}</td>
//         <td onClick={() => handleEdit(emp)}>
//           <MdOutlineEdit className='account-icon1' title='Allocate Teacher' />
//         </td>
//       </>
//     );
//   })()}
// </tr>

//     ))}

// </table>
// </div>


//               </div>
// }
//               {/* card ends */}


// </div>
// </section>


// {isEditMode && selectedTeacher && (
//   <div className='px-4 mb-4'>
//   <div className="profile-card">
//             <span className="profile-heading align-content-center">Edit Teacher Engagements</span>


// <div className='table-responsive mt-3'>
// <table className='w-100'>

// <thead className='account-thead'>
//     <th className='rounded-start-4'>Reg Id</th>
//     <th>Name</th>
//     <th>Father Name</th>
//         <th className='rounded-end-4'>Designation</th>
// </thead>


//   <tr className='account-tr'>
// <td>{selectedTeacher.user_id}</td>  
// <td>{selectedTeacher.name}</td>  
// <td>{selectedTeacher.father || '--'}</td>  
// <td>{selectedTeacher.designation}</td>  
// </tr>

// </table>
// </div>
// {/* table ends */}


// <div className='row mt-4'>


// <div className="mb-4 col-md-4 col-12">
//   <div className='profile-input-area'>
//   <label className="profile-badge">Select Class</label>
//   <select
//     className="profile-input"
//     value={selectedClass}
//     onChange={(e) => {
//       setSelectedClass(e.target.value);
//       setSelectedSection('');
//     }}
//   >
//     <option value="">-- Select Class --</option>
//     {classes.map(cls => (
//       <option key={cls} value={cls}>{cls}</option>
//     ))}
//   </select>
// </div>
// </div>

//   {selectedClass && (
//     <>
//     <div className='mb-4 col-md-4 col-12'>
//       <div className='profile-input-area'>
//       <label className="profile-badge">Select Section</label>
//       <select
//         className="profile-input"
//         value={selectedSection}
//         onChange={(e) => {
//           setSelectedSection(e.target.value);
//           setSelectedDay('');
//         }}
//       >
//         <option value="">-- Select Section --</option>
//         {sections.map(sec => (
//           <option key={sec} value={sec}>{sec}</option>
//         ))}
//       </select>
//       </div>
// </div>
//     </>
//   )}


// {selectedClass && selectedSection && (
//   <div className='mb-4 col-md-4 col-12'>
//     <div className='profile-input-area'>
//       <label className="profile-badge">Select Day</label>
//       <select
//         className="profile-input"
//         value={selectedDay}
//         onChange={(e) => setSelectedDay(e.target.value)}
//       >
//         <option value="">-- Select Day --</option>
//         {days.map(day => (
//           <option key={day} value={day}>{day}</option>
//         ))}
//       </select>
//     </div>
//   </div>
// )}


// {selectedClass && selectedSection && periods.length > 0 && (
//   <>
//     <label className="form-label">Select Period(s)</label>
//     <div className="mb-3">
//       {periods.map((item, idx) => {
//         const className = item.class_name;
//         const section = item.section;
//         const day = item.day;

//         // Loop through the periods object
// return Object.entries(item.periods).map(([label, periodData]) => {
//   const isFree = periodData === null;

//   const periodEntry = {
//     ttId: item.id,
//     label,
//     subject: isFree ? 'Free Period' : periodData.sub_name,
//     subjectId: isFree ? null : periodData.id,
//     myClass: className,
//     section,
//     day
//   };

//   const isChecked = selectedPeriods.some(p =>
//     p.ttId === item.id &&
//     p.label === label &&
//     p.myClass === className &&
//     p.section === section &&
//     p.subjectId === periodEntry.subjectId
//   );

//   return (
//     <div key={`${idx}-${label}`} className="form-check">
//       <input
//         className="form-check-input"
//         type="checkbox"
//         id={`period-${idx}-${label}`}
//         checked={isChecked}
//         onChange={(e) => {
//           const checked = e.target.checked;

//           setSelectedPeriods(prev => {
//             if (checked) {
//               return [...prev, periodEntry];
//             } else {
//               return prev.filter(p =>
//                 !(
//                   p.ttId === item.id &&
//                   p.label === label &&
//                   p.myClass === className &&
//                   p.section === section &&
//                   p.subjectId === periodEntry.subjectId
//                 )
//               );
//             }
//           });
//         }}
//       />
//       <label className="form-check-label" htmlFor={`period-${idx}-${label}`}>
//         {`${label} Period - ${periodEntry.subject}`}
//       </label>
//     </div>
//   );
// });

//       })}
//     </div>
//   </>
// )}


//   {selectedPeriods.length > 0 && (
//   <div className='mt-3'>
//     <h6>Selected Engagements</h6>
//     <ul className='list-group'>
//       {selectedPeriods.map((p, i) => (
//         <li key={i} className='list-group-item d-flex justify-content-between align-items-center'>
//           <span>
//             <strong>Day:</strong> {p.day} | <strong>Class:</strong> {p.myClass} | <strong>Section:</strong> {p.section} | <strong>Period:</strong> {p.label} | <strong>Subject:</strong> {p.subject}
//           </span>
//           <button
//                     className="ms-2 border-0 bg-transparent cursor-pointer"
//             onClick={() =>
//               setSelectedPeriods(prev => prev.filter((_, idx) => idx !== i))
//             }
//           >
// <AiOutlineMinusCircle size={26} color='red' />          </button>
//         </li>
//       ))}
//     </ul>
//   </div>
// )}


// </div>
// {/* row ends */}

//     {/* Save and Cancel buttons */}

//     <div className="text-center mt-3">
// <button
//   onClick={() => {
//     setIsEditMode(false);
//     setSelectedTeacher(null);
//   }}
//   type='button'
//   className='profile-btn2'
// >
//   Go Back
// </button>

// <button
//   className="profile-btn ms-2"
//   onClick={async () => {
// try {
//   setLoading(true);

//   const payload = {
//     teacherId: selectedTeacher.user_id,
//     engagements: selectedPeriods,
//   };

//   const res = await fetch('https://api.kcian.in/allocate-teacher', {
//     method: 'POST',
//     headers: { 'Content-Type': 'application/json' },
//     body: JSON.stringify(payload),
//   });

//   const result = await res.json();

//   if (res.status === 200) {
//     setResponse2({ message: 'Teacher Allocated Successfully', status: 'success' });
//     fetchTimeTable();
//     setIsEditMode(false);
//     setSelectedTeacher(null);
//     setSelectedClass('');
//     setSelectedSection('');
//     setSelectedPeriods([]);
//   } else if (res.status === 207) {
//     const errorMessage = result.message || 'Some conflicts occurred.';
//     const conflictsText = result.conflicts?.join('\n') || '';
//     setResponse2({ message: `${errorMessage}\n${conflictsText}`, status: 'error' });
//   } else {
//     const errorMessage = result.message || 'Something Went Wrong. Please try again.';
//     setResponse2({ message: errorMessage, status: 'error' });
//   }
// } catch (err) {
//   console.error(err);
//   setResponse2({ message: 'Something went wrong while saving.', status: 'error' });
// } finally {
//   setTimeout(() => {
//     setResponse2('');
//   }, 3000);
//   setLoading(false);
// }
//   }}
// >
//   Save
// </button>

//     </div>
// {/* button ends */}

//   </div>
//   </div>
// )}


//     </>
//   )
// }

// export default TeacherAllocation
import React, {useState, useEffect, useRef} from 'react'
import HeadingArea from '../../general/HeadingArea';
import { FaPrint } from 'react-icons/fa';
import ResponseMsg2 from '../../general/ResponseMsg2';


const TeacherAllocation = ({setLoading, userData}) => {
const [teacher, setTeacher] = useState([]);
const [searchTerm, setSearchTerm] = useState('');
const [timeTable, setTimeTable] = useState([]);
const printRef = useRef(null);
  const [response2, setResponse2] = useState({ message: '', status: 'success' });


         const fetchEmp = async () => {
                          setLoading(true);
                  try {
                      const response = await fetch('https://api.kcian.in/get-employee');
      
                      if (response.ok) {
                          const data = await response.json();
 let filteredData = data.filter(emp => emp.role == 'Teacher');

 if(userData.role == 'Teacher'){
filteredData = data.filter(emp => emp.user_id == userData.user_id);
 }

                          setTeacher(filteredData);
                          setLoading(false);
                      } else {
                          setLoading(false);
                          console.error('Failed to fetch employee');
                      }
                  } catch (error) {
                      setLoading(false);
                      console.error('Error fetching data:', error);
                  }
    }


                const fetchTimeTable = async () => {
                            setLoading(true);
                    try {
                        const response = await fetch('https://api.kcian.in/get-time-table');
        
                        if (response.ok) {
                            const data = await response.json();
                            setTimeTable(data);
                            setLoading(false);
                        } else {
                            setLoading(false);
                            console.error('Failed to fetch class');
                        }
                    } catch (error) {
                        setLoading(false);
                        console.error('Error fetching data:', error);
                    }
      }
 
     useEffect(() => {
         fetchEmp();
         fetchTimeTable();
     }, []);
      

       const filteredTeacher = teacher.filter(tt => {
  const term = searchTerm.toLowerCase();
  return (
        tt.name.toLowerCase().includes(term) ||
        tt.designation.toLowerCase().includes(term) ||
        tt.user_id.toLowerCase().includes(term)
  );
});

const getTeacherEngagements = (teacherUserId) => {
  const engagementsByDay = {};

  console.log(timeTable);

  // Iterate over all timetable entries (each day)
  timeTable.forEach((entry) => {
    const { day, periods } = entry;

    const romanOrder = {
  I: 1,
  II: 2,
  III: 3,
  IV: 4,
  V: 5,
  VI: 6,
  VII: 7,
  VIII: 8,
  IX: 9,
  X: 10,
  XI: 11,
  XII: 12,
};

    // For each period (like I, II, III...), check if teacher_user_id matches
    Object.keys(periods).forEach((periodKey) => {
      const period = periods[periodKey];

      if (period && period.teacher_user_id === teacherUserId) {
        if (!engagementsByDay[day]) {
          engagementsByDay[day] = [];
        }

        // engagementsByDay[day].push(`Period ${periodKey} - ${period.sub_name}(${period.sub_type})-${period.sub_code}`);
        engagementsByDay[day].push(
          { order: romanOrder[periodKey],
            text: `Period ${periodKey}: ${entry.class_name} ${entry.section}- ${period.sub_name}(${period.sub_type == 'Theory' ? 'TH' : 'P'})`});
      }
    });
  });

   Object.keys(engagementsByDay).forEach((day) => {
    engagementsByDay[day]
      .sort((a, b) => a.order - b.order);

    engagementsByDay[day] = engagementsByDay[day].map(item => item.text);
  });

  // If no engagements, return null
  return Object.keys(engagementsByDay).length === 0 ? null : engagementsByDay;
};


  const handlePrint = () => {
    if (!filteredTeacher.length) {
      setResponse2({ message: 'No Engagements to Print', status: 'success' });
    setTimeout(() => setResponse2({ message: '', status: '' }), 3000);
      return;
    }
    window.print();
  };

  return (
    <>
                        <section className="py-4">
        <div className="px-4">
          <HeadingArea message1="Time Table" message2="Teacher Allocation" />

       {response2.message && <ResponseMsg2 message={response2.message} status={response2.status} />}


<div className='profile-card'>
              
  <div className='d-md-flex d-sm-flex justify-content-between mb-2'>
            <span className="profile-heading align-content-center">{userData.role == 'SupAdmin' ? 'Teacher' : 'My'} Engagements</span>

{userData.role == 'SupAdmin' && 
                  <div className='profile-input-area ms-auto col-lg-3 border-0'>
<input
  type='text'
  name='search'
  className='profile-input border-bottom rounded-0'
  placeholder='Search Name, Reg Id, Designation'
  value={searchTerm}
  onChange={(e) => setSearchTerm(e.target.value)}
/>
</div>}
  </div>

            <div className="text-end d-print-none">
              <button
                className="profile-btn2"
                onClick={handlePrint}
                disabled={!filteredTeacher.length}
              >
                <FaPrint /> Print
              </button>
            </div>


<div ref={printRef} className='printable-area table-responsive mt-3'>
<table className='w-100'>

<thead className='account-thead rounded-top-4'>
  <tr>
    <th className='border d-print-none'>S No</th>
    <th className='border'>Reg Id</th>
    <th className='border'>Name</th>
    <th className='border d-print-none'>Father Name</th>
    <th colSpan={6} className='border text-center'>Engagements (in Days)</th>
    <th className='border d-print-none'>Designation</th>
        </tr>

<tr className='border-top'>
    <th className='border d-print-none'></th>
    <th className='border' colSpan={2}></th>
    <th className='border d-print-none'></th>
    <th className='border'>Mon</th>
    <th className='border'>Tues</th>
    <th className='border'>Wed</th>
    <th className='border'>Thurs</th>
    <th className='border'>Fri</th>
    <th className='border'>Sat</th>
    {/* <th className='border'>Sun</th> */}
    <th className='border d-print-none'></th>
    </tr>

</thead>

{filteredTeacher.map((emp, index) => (
  <tr className='account-tr' key={emp.user_id}>
    {(() => {
      const engagementsByDay = getTeacherEngagements(emp.user_id);
      const dayOrder = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];

      return (
        <>
          <td className='border d-print-none'>{index + 1}</td>
          <td className='border'>{emp.user_id}</td>
          <td className='border'>{emp.name}</td>
          <td className='border d-print-none'>{emp.father || ''}</td>

          {dayOrder.map(day => (
            <td className='border' key={day}>
              {engagementsByDay && engagementsByDay[day] ? (
                <ul className="mb-0 ps-3">
                  {engagementsByDay[day].map((entry, idx) => (
                    <li key={idx}>{entry}</li>
                  ))}
                </ul>
              ) : (
                <span className="text-muted">-</span>
              )}
            </td>
          ))}

          <td className='border d-print-none'>{emp.designation || '-'}</td>
        </>
      );
    })()}
  </tr>
))}


</table>
</div>


              </div>
              {/* card ends */}

              </div>
</section>


      <style>{`
@media print {
@page {
  size: landscape;
}

  body * {
    visibility: hidden;
  }
  .printable-area, .printable-area * {
    visibility: visible;
  }
  .printable-area {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    font-size: 0.8em;
  }

  .d-print-none {
    display: none !important;
  }
  .printable-area .row {
    display: flex !important;
    flex-wrap: wrap !important;
  }

}

      `}</style>

    </>
  )
}

export default TeacherAllocation
